import * as React from 'react';
import { AccVideoDetailResultVO } from '@domain/vo/acca/v1/test/result/apply/AccVideoResultVO';
import classNames from 'classnames/bind';
import styles from './v4Warning.module.scss';

const cx = classNames.bind(styles);

interface V4WarningProps {
  videoDetailTab: AccVideoDetailResultVO | null;
}

const V4Warning = ({ videoDetailTab }: V4WarningProps) => {
  if (!videoDetailTab) return null;
  const { videoErrorYn, voiceErrorYn } = videoDetailTab;
  if (!videoErrorYn && !voiceErrorYn) return null;

  const getWarningText = () => {
    if (videoErrorYn && voiceErrorYn) {
      return (
        <>
          현재 제출된 영상이나 음성을 분석하기 어려워요.
          <br />
          밝고 조용한 환경에서 실제 면접처럼 또박또박 침착하게 응답해 보세요.
        </>
      );
    } else if (videoErrorYn && !voiceErrorYn) {
      return (
        <>
          현재 제출된 영상을 분석하기 어려워요.
          <br />
          환경체크를 할 때의 밝기, 거리, 바른 자세를 유지하며 침착하게 응답해 보세요.
        </>
      );
    } else if (!videoErrorYn && voiceErrorYn) {
      return (
        <>
          현재 제출된 음성을 분석하기 어려워요.
          <br />
          조용한 환경에서 실제 면접처럼 또박또박 침착하게 응답해 보세요.
        </>
      );
    }
    return null;
  };

  return <div className={cx('warningWrap')}>{getWarningText()}</div>;
};

export default V4Warning;
